import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MarketingMan from "../../asset/images/marketing/man-img.jpg"
import MarketingFamily from "../../asset/images/marketing/family-img.jpg"
import MarketingProtect from "../../asset/images/marketing/protection-plan-img.jpg"
import Mplanning1 from "../../asset/images/marketing/planning-posters-first.jpg"
import Mplanning2 from "../../asset/images/marketing/planning-posters-second.jpg"
import Mplanning3 from "../../asset/images/marketing/planning-posters-third.jpg"
import Mfuture from "../../asset/images/marketing/future-planning.jpg"
import Mgrow from "../../asset/images/marketing/grow-business.jpg"
import Mfuture2 from "../../asset/images/marketing/future-planning-snd-img.jpg"
import Header from '../../Components/Header';
import Sidebar from '../../Components/Sidebar';
import SingleSignOnSideBar from '../../Components/SingleSignOnSideBar';


function MarketingMaterial() {
  const MarketSlider = {
    dots: true,
    arrows: false,
    autoplay: false,
    infinite: true,
    //   speed: 300,
    slidesToShow: 3,
    slidesToScroll: 2,

    responsive: [
      {
        breakpoint: 922,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <>
      <Header/>
      {/* <Sidebar/> */}
      <SingleSignOnSideBar/>
      <main id="main-content">
        <div className="marketing-material">
            <ul className="page-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" id="brochures-tab" data-bs-toggle="tab" data-bs-target="#Brochures" type="button" role="tab" aria-controls="brochures" aria-selected="true">Brochures</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="infographics-tab" data-bs-toggle="tab" data-bs-target="#infographics" type="button" role="tab" aria-controls="infographics" aria-selected="false">Infographics</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="invitations-tab" data-bs-toggle="tab" data-bs-target="#invitations" type="button" role="tab" aria-controls="invitations" aria-selected="false">Invitations</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="multimedia-tab" data-bs-toggle="tab" data-bs-target="#multimedia" type="button" role="tab" aria-controls="multimedia" aria-selected="false">Multimedia</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="newsletters-tab" data-bs-toggle="tab" data-bs-target="#newsletters" type="button" role="tab" aria-controls="newsletters" aria-selected="false">Newsletters</button>
              </li>
            </ul>
          <div className="tab-content" id="myTabContent" >
            <div className="tab-pane fade show active" id="Brochures" role="tabpanel" aria-labelledby="Brochures-tab">
              {/* flyers */}
              <div className="flyers marketing-card-slider bottom-25">
                <div className="card-box">
                  <div className="card-title">
                    <h2>Flyers</h2>
                  </div>
                  <Slider {...MarketSlider} className="marketing-slider">
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={MarketingMan} alt="man-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={MarketingFamily} alt="family-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={MarketingProtect} alt="protection-plan-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={MarketingFamily} alt="family-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={MarketingProtect} alt="protection-plan-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={MarketingProtect} alt="protection-plan-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                  </Slider>
                </div>
              </div>
              {/* posters */}
              <div className="posters marketing-card-slider bottom-25">
                <div className="card-box">
                  <div className="card-title">
                    <h2>Posters</h2>
                  </div>
                  <Slider {...MarketSlider} className="marketing-slider">
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mplanning1} alt="man-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mplanning2} alt="family-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mplanning3} alt="protection-plan-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mplanning2} alt="family-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mplanning2} alt="protection-plan-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mplanning2} alt="protection-plan-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                  </Slider>

                </div>
              </div>
              {/* display-material */}
              <div className="display-material marketing-card-slider">
                <div className="card-box">
                  <div className="card-title">
                    <h2>Display Material</h2>
                  </div>
                  <Slider {...MarketSlider} className="marketing-slider">
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mfuture} alt="man-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mgrow} alt="family-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mfuture2} alt="protection-plan-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mfuture} alt="family-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mgrow} alt="protection-plan-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                    <li className="card-slider-item">
                      <div className="card-slider-img-wrapper">
                        <img src={Mgrow} alt="protection-plan-img" className="card-slider-img" />
                        <div className="card-img-hover-item">
                          <a href="javascript:void(0)">
                            <span className="icon-eye" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-file-download" />
                          </a>
                          <a href="javascript:void(0)">
                            <span className="icon-share-icon" />
                          </a>
                        </div>
                      </div>
                    </li>
                  </Slider>

                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="infographics" role="tabpanel" aria-labelledby="infographics-tab">...
            </div>
            <div className="tab-pane fade" id="invitations" role="tabpanel" aria-labelledby="invitations-tab">...</div>
            <div className="tab-pane fade" id="multimedia" role="tabpanel" aria-labelledby="multimedia-tab">...
            </div>
            <div className="tab-pane fade" id="newsletters" role="tabpanel" aria-labelledby="newsletters-tab">...
            </div>
          </div>
        </div>
      </main>


    </>
  )
}
export default MarketingMaterial